// extracted by mini-css-extract-plugin
export default {"loading_wrapper":"user_entry_point_loading_wrapper__-+78V","logo":"user_entry_point_logo__csr1W"};